import { Globals } from "../../logic/services/Globals";
//import ServerAPIService from "../services/ServerAPIService.ts_";
import HTTPService from "../../../../common/main/services/http/http.service";
import { IHTTPPostProps } from "../../../../common/main/services/http/http.interfaces";
import { IJSONOutEmail } from "../jsons/out/JSONOutEmail";
import { ELng } from "../../../../language/main/LanguageKeysEnums";


export default class ServerEMailAPIService {

  constructor() { }

  //#region POST 
  public static async send(json: IJSONOutEmail | null | undefined): Promise<string | null> {
    return new Promise<string | null>(async (resolve, reject) => {
      if(json == null || json == undefined) throw Error(ELng.msg_error_jsons_are_null.valueOf())
      let url = Globals.baseAPIUrl + '?route=/email';
      //let props: IHTTPPostProps<IJSONOutEmail> = { url: url, headerItems: ServerAPIService.getAuthHeaderItems(), contentToSend: json };
      let props: IHTTPPostProps<IJSONOutEmail> = { url: url, contentToSend: json };

      try {

        let response = await HTTPService.HttpPostJSON<IJSONOutEmail, string>(props);
        if (!response.content?.success) return reject(response?.content?.message)
        let json: string | null = response.content?.message;
        if (json == null || json == undefined) { return reject(response.content.message) }

        return resolve(json);

      } catch (e) {
        return reject(e?.toString())
      }
    })
  }
  //#endregion
}